"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue, Ref } from "vue-property-decorator";
import UiForm, {
  UiFormAnnotations,
  UiFormController
} from "@/components/form/UiForm.vue";
import UiDialog from "@/components/dialog/UiDialog.vue";
import UiSubmit from "@/components/form/UiSubmit.vue";
import PasswordInput from "@/views/accountItems/components/PasswordInput.vue";
import i18n from "@/lang";
import API from "@ym-framework/api-utils";
class teamSettingController extends UiFormController {
  constructor() {
    super(...arguments);
    this.teamName = "";
    this.allow_join = false;
    this.allow_invite = false;
    this.change_team_audit = false;
    this.auto_update = false;
    this.update_password_notice_day = 30;
  }
}
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: "\u8BF7\u8F93\u5165\u56E2\u961F\u540D\u79F0",
      trigger: "blur"
    }
  ])
], teamSettingController.prototype, "teamName", 2);
class TeamVerifyController extends UiFormController {
  constructor() {
    super(...arguments);
    this.password = "";
  }
}
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t("team_management.team_settings.dialog.message"),
      trigger: "blur"
    }
  ])
], TeamVerifyController.prototype, "password", 2);
let teamSettings = class extends Vue {
  constructor() {
    super(...arguments);
    this.team_setting_controller = new teamSettingController();
    this.change_team_verify = false;
    this.verifyController = new TeamVerifyController();
    this.verify_password = false;
  }
  created() {
    return __async(this, null, function* () {
    });
  }
  mounted() {
    this.getOptions();
  }
  getOptions() {
    return __async(this, null, function* () {
      try {
        const response = yield API.get("api://base.auth/api/v7/teamSettings");
        if (response.data) {
          this.team_setting_controller.teamName = response.data.name;
          this.team_setting_controller.allow_join = response.data.join;
          this.team_setting_controller.allow_invite = response.data.invite;
          this.team_setting_controller.change_team_audit = response.data.switch_org_verify;
          this.change_team_verify = response.data.switch_org_verify;
          this.team_setting_controller.auto_update = response.data.auto_update;
          this.team_setting_controller.update_password_notice_day = response.data.update_password_notice_day;
        }
        console.dir(response);
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  submitTeam() {
    return __async(this, null, function* () {
      try {
        const response = yield API.put("api://base.auth/api/v7/teamSettings", {
          auto_update: this.team_setting_controller.auto_update,
          invite: this.team_setting_controller.allow_invite,
          join: this.team_setting_controller.allow_join,
          name: this.team_setting_controller.teamName,
          switch_org_verify: this.team_setting_controller.change_team_audit,
          update_password_notice_day: this.team_setting_controller.update_password_notice_day
        });
        this.$message.success(
          this.$t("team_management.team_settings.success")
        );
        yield this.getOptions();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  changeSwitchVerify() {
    return __async(this, null, function* () {
      if (this.change_team_verify === true && this.team_setting_controller.change_team_audit === false) {
        this._change_verify.show();
      }
    });
  }
  VerifyPassword() {
    return __async(this, null, function* () {
      try {
        this.verify_password = false;
        let response = yield API.post(
          `api://base.auth/api/v1/account/orgs/show/password/valid`,
          {
            password: this.verifyController.password
          }
        );
        let _valid = response.data.status;
        if (_valid === "PASSWORD_VALID_FALI") {
          this.$message.error(
            this.$t(
              "team_management.team_settings.dialog.password_valid_fali"
            )
          );
          return;
        }
        this.verify_password = true;
        this.closeVerify();
      } catch (error) {
        console.log(error);
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  closeVerify() {
    this._change_verify.hide();
    this.verifyController.password = "";
    if (this.verify_password === false) {
      this.team_setting_controller.change_team_audit = true;
    }
    if (this.verify_password === true) {
      this.team_setting_controller.change_team_audit = false;
    }
  }
};
__decorateClass([
  Ref("change-team-verify-dialog")
], teamSettings.prototype, "_change_verify", 2);
teamSettings = __decorateClass([
  Component({
    components: {
      UiForm,
      UiDialog,
      UiSubmit,
      PasswordInput
    }
  })
], teamSettings);
export {
  teamSettings as default
};
